export default __webpack_public_path__ + "static/media/slide11.ac056066.webp";